import React from "react";
import "./index.css";
import cn from "classnames";
import BgTransformer from "layout/BgTransformer";
import PixelationLayer from "layout/PixelationLayer";
import {useSetting} from "contexts/setting";
import {useBgUrl} from "hooks/useBgUrl";

const WallpaperPreview = ({id, zoom}) => {
  const {product} = useSetting();
  const {url: bgUrl} = useBgUrl();

  // Preview template typically just shows the background or simplified view
  // Based on Figma structure, it has no content slot, just bg-transformer

  return (
    <div
      id={id}
      className={cn("template", product.value, "wallpaper-preview")}
      style={{"--zoom-level": zoom}}
    >
      <div>
        <div>
          <BgTransformer src={bgUrl} id={id} />
          <PixelationLayer />
        </div>
        <div className="content"></div>
      </div>
    </div>
  );
};

export default WallpaperPreview;
